import React from 'react';

import { Alert } from '@material-ui/lab';
import styled from 'styled-components';

import { Typography12 } from 'uiToolkit/Typography';

const Wrapper = styled.div`
  .MuiAlert-root {
    padding: 0.25rem 3rem;
  }
`;

const HelloBar = ({ message, handleClose, severity = 'error', closeText = 'Dismiss', iconMapping = {} }) => (
  <Wrapper>
    <Alert
      severity={severity}
      onClose={() => {
        handleClose?.();
      }}
      iconMapping={iconMapping}
      closeText={closeText}
    >
      <Typography12>{message}</Typography12>
    </Alert>
  </Wrapper>
);

export default HelloBar;
